import React from "react"
import { Route, Switch } from "react-router"
import { Redirect, useParams } from "react-router-dom"
import useCompany from "components/companies/hooks/useCompany"
import Topups from "./topup"
import { Heading, ChakraProvider } from "@chakra-ui/react"
import Exoskeleton from "../../components/Exoskeleton"
import { theme } from "../../utils/theme"

export default function CarrotCardAccounts(): JSX.Element {
  return (
    <div>
      <Switch>
        <Route path={"/companies/:companyId"} render={(): JSX.Element => <Company />} />
        <Redirect to="/404" />
      </Switch>
    </div>
  )
}

function Company(): JSX.Element {
  const { companyId } = useParams<{ companyId: string }>()
  const { data: company, isLoading } = useCompany(Number(companyId))

  return (
    <ChakraProvider theme={theme}>
      <Exoskeleton isLoading={isLoading}>
        {isLoading ? null : (
          <div>
            <Heading size="lg" color="blue.400" mt="45px">
              {company.name}
            </Heading>
            <Switch>
              <Route
                exact
                path={"/companies/:companyId/topups"}
                render={(): JSX.Element => <Topups company={company} />}
              />
              <Redirect to="/404" />
            </Switch>
          </div>
        )}
      </Exoskeleton>
    </ChakraProvider>
  )
}
